import styled from "styled-components";

export const Container = styled.div`
  margin-top: 0;
  width: 100%;
  min-width: 0;
`;

export const Carousel = styled.div`
  display: flex;
  overflow-x: auto;
  overflow-y: hidden;
  padding: 0;
  width: 100%;
  min-width: 0;
  -webkit-overflow-scrolling: touch;
  scroll-behavior: smooth;
  scroll-snap-type: x mandatory;
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const Item = styled.div`
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 100%;
  width: 100%;
  min-height: 28px;
  padding: 0 16px;
  text-align: center;
  box-sizing: border-box;
  scroll-snap-align: start;
`;

export const ItemInner = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 4px;
  width: 100%;
`;

export const LeftIcon = styled.img`
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  object-fit: contain;
`;

export const Title = styled.div`
  font-size: 12px;
  font-weight: 700;
  color: #4a4a4a;
`;
